"use client";
import useDebounceSearch from "@/hooks/useDebounceSearch";
import { FAQResponseType } from "@/types/post";

import FAQInput from "./FAQInput";
import FAQList from "./FAQList";

interface FAQSectionProps {
  faqs: FAQResponseType[];
}

function FAQSection({ faqs }: FAQSectionProps) {
  const { keyword, onChangeSearch } = useDebounceSearch();

  const filtered = faqs.filter((faq) => faq.title.includes(keyword) || faq.content.includes(keyword));

  return (
    <section className="mt-20 w-full px-side py-32">
      <div className="mx-auto w-full max-w-[800px]">
        <h2 className="mb-12 text-center text-36 font-semibold">궁금한 점이 있으신가요?</h2>
        <FAQInput className="mb-10" onChange={onChangeSearch} />
        <FAQList faqs={filtered} />
      </div>
    </section>
  );
}

export default FAQSection;
